import React from 'react';
import styled from 'styled-components';
import { Paragraph } from 'components/atoms/SectionWrapper.style';
import { cms } from 'assets/cms';

const ElementsWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin-top: 150px;
  @media ${({ theme }) => theme.media.tablet} {
    flex-direction: row;
  }
  div {
    margin: 10px auto;
    padding: 10px;

    img {
      height: 50px;
    }
    span {
      font-weight: bold;
    }

    @media ${({ theme }) => theme.media.tablet} {
      margin: 10px auto;
    }
  }
`;

const OptimalizationIcons = () => (
  <>
    <ElementsWrapper>
      <div>
        <img src={cms.icons.problem} />
        <Paragraph>
          <span>Znalezienie źródeł problemu</span>
          <br /> Zbyt wysokie zużycie prądu może mieć wiele przyczyn. Od
          korzystania z urządzeń i maszyn o dużym zapotrzebowaniu na prąd,
          poprzez złe praktyki w używaniu energii, aż po niewłaściwie dopasowane
          taryfy prądu u swojego dostawcy.
        </Paragraph>
      </div>
      <div>
        <img src={cms.icons.interview} />
        <Paragraph>
          <span> Zaproponowanie skutecznych rozwiązań </span>
          <br /> Znajdziemy najlepsze rozwiązania, które pozwolą ograniczyć
          zużycie prąd, bez utraty jakości pracy, a nawet z jej zwiększeniem.
          Nowoczesne technologie są efektywne i coraz bardziej dostępne dla
          budżetu.
        </Paragraph>
      </div>
      <div>
        <img src={cms.icons.settings} />
        <Paragraph>
          <span> Wdrożenie zmian</span> <br /> Zajmiemy się kompleksowym
          wdrożeniem zmian i ich realizacją. Wykonamy instalacje PV,
          zmodernizujemy sieć elektryczną, wyposażymy ją w energooszczędne
          urządzenia i przeprowadzimy szkolenia wśród pracowników.
        </Paragraph>
      </div>
    </ElementsWrapper>
  </>
);

export default OptimalizationIcons;
